import { createContext } from "react";
// loader context
// @ts-ignore
export const LoaderContext = createContext<any>();
